import dayjs from "dayjs";
import moment from "moment";
import { getUser } from "../../../utils/helpers";

export const DEFAULT_DATE_FORMAT = "MM/DD/YYYY";

/**
 * Return the date range for the history tab
 * @param {*} selectedDateObj antd date object
 * @returns {object} {startDate, endDate}
 */
export const getHistoryDates = (selectedDateObj = null) => {
  const user = getUser();
  const noPermissionDates = { startDate: dayjs().add(-1, "M"), endDate: dayjs() };
  if (!user.permissionMap) {
    return noPermissionDates;
  }
  // Return current month if user has permission
  if (user.permissionMap.view_sendreports_history_date) {
    const startDate = selectedDateObj || dayjs(moment().startOf("month").format(DEFAULT_DATE_FORMAT), DEFAULT_DATE_FORMAT);
    const endDate = selectedDateObj ? dayjs(moment(selectedDateObj.$d).endOf("month").format(DEFAULT_DATE_FORMAT), DEFAULT_DATE_FORMAT) : dayjs();
    return { startDate, endDate };
  }

  // Return last two weeks if user doesn't have permission
  return noPermissionDates;
};
